import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useHistory, useParams } from 'react-router-dom'
import { planMenuApiErrorCodeOptions } from '../constants'
import { useSnackbar } from '../../../components/stories/molecules/snackbar/component/snackbar-hook'
import { snackbarVariantOptions } from '../../../components/stories/molecules/snackbar/constants'
import CreateFolderModal from '../../../components/create-folder-modal'
import { useCreatePlanFolderMutation } from '../../../react-query/plan/mutation/use-create-plan-folder-mutation'
import { recursiveListTypeOptions } from '../../../components/recursive-folder-list/constants'
import { trackFirebaseEvent } from '../../../firebase/firebase-analytics'
import { usePlanMenuListViewControl } from '../../../hooks/use-plan-menu-list-view-control'
import { useGetProjectDetailsQuery } from '../../../react-query/project/query/use-get-project-details-query'

const CreateFolderModalWrapper = () => {
  const history = useHistory()
  const { formatMessage } = useIntl()
  const { addSnackbar } = useSnackbar()

  const { viewType } = usePlanMenuListViewControl()

  const { parentId: defaultFolderId, projectId } = useParams()
  const [folderCreationError, setFolderCreationError] = useState(null)
  const [folderNameHint, setFolderNameHint] = useState(null)

  const { data: projectDetails, isLoading: projectDetailsLoading } =
    useGetProjectDetailsQuery({
      projectId
    })

  const planRootFolderId = projectDetails?.planRootFolderId

  const showSnackbarSuccess = () => {
    addSnackbar({
      message: formatMessage({ id: 'projectMenu_folder_created' }),
      snackbarType: snackbarVariantOptions.SUCCESS,
      hideCloseButton: true
    })
  }

  const handleOnClose = () => {
    history.push(`/project/${projectId}?view=${viewType}`)
  }

  const handleFolderCreationError = (error) => {
    if (
      error &&
      error?.response?.data?.status ===
        planMenuApiErrorCodeOptions.NO_PERMISSION_TO_CREATE_PLAN_OR_FOLDER
    ) {
      return setFolderCreationError(
        formatMessage({
          id: 'projectMenu_no_permission_to_create'
        })
      )
    }

    if (
      error &&
      error?.response?.data?.status ===
        planMenuApiErrorCodeOptions.FOLDER_NAME_IS_NOT_AVAILABLE
    ) {
      return setFolderNameHint(
        formatMessage({
          id: 'projectMenu_folder_with_this_name_aready_exists'
        })
      )
    }

    return setFolderCreationError(
      formatMessage({
        id: 'projectMenu_project_create_error'
      })
    )
  }

  const handleFolderCreated = () => {
    trackFirebaseEvent('plan_folder_create_success', {
      source: 'plan_list'
    })

    handleOnClose()
    showSnackbarSuccess()
  }

  // Mutations
  const { mutate: createFolder, isPending: createFolderLoading } =
    useCreatePlanFolderMutation({
      onSuccess: handleFolderCreated,
      onError: handleFolderCreationError
    })

  // handlers

  const handleCreateFolder = ({ folderName, parentFolderId }) => {
    setFolderCreationError(null)
    setFolderNameHint(null)
    createFolder({
      folderName,
      parentFolderId,
      projectId
    })
  }

  useEffect(() => {
    trackFirebaseEvent('plan_folder_create_start', {
      source: 'plan_list'
    })
  }, [])

  return (
    <CreateFolderModal
      handleCreate={handleCreateFolder}
      handleClose={handleOnClose}
      createFolderError={folderCreationError}
      createFolderLoading={createFolderLoading}
      isLoading={projectDetailsLoading}
      defaultFolderId={defaultFolderId}
      folderNameHintMessage={folderNameHint}
      foldersListType={recursiveListTypeOptions.PLAN}
      projectId={projectId}
      planRootFolderId={planRootFolderId}
    />
  )
}

export default CreateFolderModalWrapper
